import Trans from "../intl/Trans";
import Link from "../../vendor/router/Link";
import routes from "../router/routes";
import React from "react";
import PropTypes from "prop-types";
import Error500Icon from "../../../resources/images/icons/Error500Icon.png";
InternalServerErrorPage.propTypes = {
    hasIdentity: PropTypes.bool
};
export default function InternalServerErrorPage(param) {
    var _param_hasIdentity = param.hasIdentity, hasIdentity = _param_hasIdentity === void 0 ? false : _param_hasIdentity;
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex min-h-[calc(100vh-180px)] flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8"
    }, /*#__PURE__*/ React.createElement("img", {
        src: Error500Icon,
        alt: "Internal server error icon",
        className: "mx-auto mb-8 h-56 w-56 sm:mb-12 sm:h-72 sm:w-72"
    }), /*#__PURE__*/ React.createElement("h1", {
        className: "mb-6 mt-4 text-2xl font-bold dark:text-white"
    }, /*#__PURE__*/ React.createElement(Trans, null, "common.errors.pages.internal-server-error.title")), /*#__PURE__*/ React.createElement("p", {
        className: "text-gray-600 dark:text-gray-400"
    }, /*#__PURE__*/ React.createElement(Trans, null, "common.errors.pages.internal-server-error.subtitle")), /*#__PURE__*/ React.createElement("div", {
        className: "mt-5 flex flex-col items-center justify-center gap-2 sm:flex-row sm:gap-3"
    }, hasIdentity && /*#__PURE__*/ React.createElement(Link, {
        to: routes.DASHBOARD,
        className: "inline-flex w-full items-center justify-center gap-2 rounded-md border border-transparent px-4 py-3 text-sm font-semibold text-blue-500 ring-offset-white transition-all hover:text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:ring-offset-slate-900 sm:w-auto"
    }, /*#__PURE__*/ React.createElement("svg", {
        className: "h-2.5 w-2.5",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M11.2792 1.64001L5.63273 7.28646C5.43747 7.48172 5.43747 7.79831 5.63273 7.99357L11.2792 13.64",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    })), /*#__PURE__*/ React.createElement(Trans, null, "common.errors.pages.internal-server-error.back-btn"))));
}
